export enum ReportCode {
  Psg10Report = '36ce3d96-f85f-4e76-aa87-76693f67978d',
  Psg10AReport = '372827dd-35e8-4744-9df8-c2386dc9a00d',
  Psg12Report = '31d36732-c730-4d2f-ab24-19744756c204',
  DailyRoadReport = '596a95f6-aa89-4040-90be-4a202aca6623',
  StopsReport = '127a133d-78e3-46da-834f-e29614ee8195',
  RoadReport = '3f7f3876-649b-4170-96a2-04672d021f6a',
  FleetStatusReport = '491f5eaa-1c21-4b84-acc4-b4afb5273992',
  VehicleUsageVatSettlementReport = 'c17000a5-ff26-4ed7-a206-9580897e7754',
  CorporateUsageSummaryReport = 'eb1d32a4-8d89-42ea-ad9a-622d8d4f7577',
  WorkCardReport = 'b5d5b5a5-9513-4e01-b30a-26b6d6c1167f',
  DriverWorkCardReport = '52a78c82-68ac-462b-96b7-db704da62cc8',
  UnitsWorkCardSummaryReport = '3461ed53-a3e9-441c-b130-ad9dfb04afe1',
  FuelReport = '93d6f785-96b9-486d-ab2c-2911b4af6ea9',
  PrivateUseReport = '9b17cd92-1040-4078-aea6-c45469950210',
  OverspeedingReport = '7a1220e7-29af-4e4e-ae2f-e64715f438c5',
  TasksReport = '755ef73f-65e8-4892-940c-56475bb76137',
  VehicleUsageReport = 'aef68a01-ea32-4939-9b5c-eb5b1b968d48',
  UnitHistoryReport = '66d29260-7226-4773-9e16-d1397dcdd830',
  IdlingReport = '0c581188-8bed-41b6-9c33-7939886d41ee',
  DataContinuityReport = '',
  ClientAccumulatedMillageReport = '',
  WinterReport = '907a088b-1df2-4542-bf85-9845e769eae0',
  ZoneVisitsReport = 'fa968d24-0273-456f-8e73-00dca02f1925',
  TripsReport = '0c43f703-ce72-4f6c-aa2a-3608a8495c7a',
  MileageReport = 'd7773afa-bdba-44ea-8b63-56daa5b4500e',
  FuelingStationReport = '0c45d23a-e0f8-442b-a8b1-17c1f792061e',
  BorderCrossingReport = '82607137-b1dc-4bc1-8563-e0454bbd0d73'
}
